import { useHref, useParams } from 'react-router-dom'

type UseGenerateCourseLinkProps = {
  isOpenCatalog?: boolean
}

export const useGenerateCourseLink = ({ isOpenCatalog }: UseGenerateCourseLinkProps = {}) => {
  const { objectiveId } = useParams()
  const catalogPath = isOpenCatalog ? '/open-catalog' : '/courses'
  const href = useHref({ pathname: `${catalogPath}/${objectiveId}/view/details` })
  const origin = window.location.origin

  return `${origin}${href}`
}
